import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-coupon',
    templateUrl: './dlg-coupon.component.pug',
    styleUrls: ['./dlg-coupon.component.less'],
})
export class DlgCouponComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DlgCouponComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
    }

    onClose() {
        this.dialogRef.close(false);
    }
}
